import EsgGeographicalExposure from './esgExposureComponents/EsgGeographicalExposureChart.component';
import EsgSectorExposure from './esgExposureComponents/EsgSectorExposureChart.component';
import GridItem from '../../../layout/GridComponents/GridItem';
import DisplayAreaCenteredWrapper from '../../../layout/utilities/displayAreaWrapper';
import EsgPortfolioScoresTable from './esgExposureComponents/EsgExposureScoresTable.component';
import EsgBusinessInvolvementPanel from './EsgBusinessInvolvement.component';
import { Grid, Typography } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  EsgPages,
  useEsgFundData,
  type EsgPortfolioSummaryPageModel,
  type EsgPortfolioSummaryPayload,
} from '../../../../api/rs-hg/esg';

const EsgComplianceGrid = ({
  esgData,
}: {
  esgData: EsgPortfolioSummaryPayload;
}) => {
  return (
    <Grid container spacing={3} style={{ margin: 0 }}>
      <GridItem
        card
        lg={12}
        cardStyle={{
          padding: '0.62rem',
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: 'white',
        }}
      >
        <EsgPortfolioScoresTable
          data={esgData}
          title="ESG Portfolio Scores"
        />
      </GridItem>
      <GridItem
        card
        lg={12}
        cardStyle={{
          padding: '0.62rem',
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: 'white',
        }}
      >
        <EsgBusinessInvolvementPanel data={esgData} />
      </GridItem>
      <GridItem
        card
        lg={12}
        cardStyle={{
          padding: '0.62rem',
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: 'white',
        }}
      >
        <EsgSectorExposure esgData={esgData.sector_scores} />
      </GridItem>
      <GridItem
        card
        lg={12}
        cardStyle={{
          padding: '0.62rem',
          height: '60%',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: 'white',
          minHeight: '18.75rem',
        }}
      >
        <EsgGeographicalExposure esgData={esgData.geographical_scores} />
      </GridItem>
    </Grid>
  );
};

const ESGCompliance = ({ fundId, positionDate }: FundInfoComponentProps) => {
  const portfolioSummaryQuery = useEsgFundData(
    fundId,
    positionDate,
    EsgPages.ESG,
  );

  return (
    <QueryBoundary<EsgPortfolioSummaryPageModel>
      isLoading={portfolioSummaryQuery.isLoading}
      isFetching={portfolioSummaryQuery.isFetching}
      isError={portfolioSummaryQuery.isError}
      error={portfolioSummaryQuery.error}
      data={
        portfolioSummaryQuery.data?.data &&
        Object.keys(portfolioSummaryQuery.data.data).length > 0 &&
        !('no data' in portfolioSummaryQuery.data.data) &&
        !(portfolioSummaryQuery.data.data as { error?: unknown }).error
          ? portfolioSummaryQuery.data
          : null
      }
      loadingMessages={['Loading ESG Data...']}
      errorMessage="No ESG Data Found"
      noDataMessage="No ESG Data Found"
    >
      {(pageModel) =>
        pageModel.data ? (
          <EsgComplianceGrid esgData={pageModel.data} />
        ) : (
          <DisplayAreaCenteredWrapper noMinHeight>
            <Typography variant="h1">{'No Data Available'}</Typography>{' '}
          </DisplayAreaCenteredWrapper>
        )
      }
    </QueryBoundary>
  );
};

export default ESGCompliance;
